/** Build a search string that targets predictions for a fixture matchup. */
export function fixturePredictionsSearchQuery(homeTeam, awayTeam) {
  return [homeTeam?.name, awayTeam?.name].filter(Boolean).join(" ").trim();
}

/** Router state payload for /app/predictions deep-linking to a fixture. */
export function buildPredictionsNavigationState({ homeTeam, awayTeam, mode } = {}) {
  const searchQuery = fixturePredictionsSearchQuery(homeTeam, awayTeam);
  const state = {};
  if (searchQuery) state.searchQuery = searchQuery;
  if (mode === "ai" || mode === "community") state.mode = mode;
  return Object.keys(state).length ? state : undefined;
}

/** Navigate to predictions filtered to a fixture (optionally on AI or community tab). */
export function goToFixturePredictions(navigate, { homeTeam, awayTeam, mode } = {}) {
  navigate("/app/predictions", {
    state: buildPredictionsNavigationState({ homeTeam, awayTeam, mode }),
  });
}
